import React, { useState, useEffect } from "react";

export const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewbox="0 0 20 20" fill="none" aria-hidden="true"><path fill="currentColor" d="M5.4 6.4A2 2 0 0 0 4 3a2 2 0 1 0 1.2 3.6l.2-.2ZM7 5c0 .5-.1 1-.3 1.4l.4.2.2.1h.5l.4-.1h.3v-.1l-.6.2.2.1.4.2a20.6 20.6 0 0 0 .6 0l.6-.3-1-.3H10.1l1 .4h.2l-.2-.2v-.2h.5l.3.2.2.1V7h.1l.2.2v.1l.3.3.5.6-.2.2h.6l.2.3h-.1l-.7.4.3.1c.3-.2.8-.3 1.1-.3 1.4.3 2.2 1.1 2.4 1.8v.1c1.4-3 1.2-5 1.1-6-1-.6-3.3-1.8-8-1.8-1.3 0-2.5.1-3.4.3.3.5.5 1 .5 1.7ZM6.6 6.5v.1l.2.2h.3l-.5-.3ZM5.3 7.7ZM4 8a3 3 0 0 1-2-.7l.5 2c0 .3.2.5.4.7.5.7 1.4.8 2.2.9h.2c4.9.6 7.2 3.2 8 5 .8-.7 1.7-1.8 2.5-3.2.5-.7 0-1.1-.6-1.1s-1.3-.2-1.8-.8c-.3.4-.6.4-.7.4-.1 0-.5-.1-.7-.3-.2-.2-.2-.6-.2-.6l-.6-.2-.8-.4h-.1c-.3 0-.6 0-.9-.2l-.3.6c-.2.1-.6.3-1 .3-.2 0-.8-.3-1-.7-.2-.4 0-.9 0-.9h-.3l-.2-.2s-.3.3-.8.2c-.4-.1-.7-.5-.8-.8v-.2A3 3 0 0 1 4 8ZM6 7.2a3 3 0 0 1-.5.4v.3h.2v-.2.1-.2H6v.1h.1H6v-.3h.2H6L6 7.1ZM6.4 6.8ZM6.5 6.7h.1-.1Z"></path><path fill="currentColor" d="M9.4 7.5h-.9v-.3l.9.3ZM11.5 7.3h-.1l.2.4.6.2c-.3-.5-.7-.6-.7-.6ZM9.2 8s.5.1.8.5H9.7l-.5-.4ZM8.4 9.5l.2.5-.6-.1.4-.4ZM9.7 8l.4.4c.3-.3 1-.4 1.8-.4-1.2-.2-2.2 0-2.2 0ZM11 9.6l.5-.5v.1l.3.1-.5.4H11Z"></path><path fill="currentColor" d="m11.1 7-.3-.1h-.9s-.3 0-.4.2l-.3.1.1.2.3.3h1.7v-.3L11 7Z"></path><path fill="currentColor" fill-rule="evenodd" d="M8.1 7.3h.2L8.2 7H8v.3Zm0 0v-.1h.1l-.1.1Z" clip-rule="evenodd"></path><path fill="currentColor" d="m13.5 9.8-.3.3h.4l-.1-.3ZM7.1 8.2h-.2c-.2-.1-.1-.3-.1-.4V8c0 .2 0 .2.2.2-.2 0-.2-.3 0-.5H7s0-.1-.1 0l-.2.2h-.2l-.3-.4-.1.3.2.3v.1h-.1v.1l-.2.1-.4-.3v.2s0 .2.2.3h.5c.1.1.2 0 .2 0h.2l.1-.1h.4c.2-.2.6-.5.9-.5.3 0 .7 0 1.1.4.4.4.3.9.3.9l.7.2-.4-.2C9.7 8.6 9.1 8 9.1 8h-.4l-.1-.2v-.1l-.2-.2h-.7c-.2-.1-.2 0-.2 0h.8v.2h-1V8l-.2.2ZM13.1 10.4l.1.4.2-.2.2-.3h-.4ZM13 10v.1l.3-.3-.3.2ZM12.2 9.5l-.2-.1-.4.5h.3c0-.2.3-.4.3-.4ZM12.9 10.2l-.2.5.2-.4v-.1ZM12.7 8.2v.1h-.3l-.2.1-.4.2v.2l-.2.3.8.2.3-.1-.8-.4v-.1s.3-.3 1-.3v-.2h-.2ZM13.1 10.9l-.1-.4-.2.3h.3ZM8.3 7.4h.1v-.2h-.1s.1 0 0 .1c.1 0 0 0 0 0Z"></path><path fill="currentColor" d="M8 9c-.2.5 0 .7 0 .7l.3-.4L8 9ZM4.7 12.1c-.4 0-.9.2-.6.6 2.2 3.6 4.5 4.7 5.6 5.2l.3.1 2.1-1.2c.2 0 .3-.2.4-.3a6.6 6.6 0 0 0-3-3.3c-1.4-.6-3.1-1-4.8-1.1ZM13.4 9.3c1-.4 2.7.7 2.8 2-.2-.3-.6-.3-1-.3-.6 0-1.1 0-1.6-.4.2-.3.2-.6.2-.8 0-.3-.1-.3-.3-.4ZM6 7.8V8v-.2ZM8.6 9.4l.2.5c.3-.2.4-.5.4-.5h-.5ZM8.7 9v.1h.5c0-.3-.3-.4-.3-.4l-.2.4ZM5.8 7.7v.2-.2ZM8.2 8.9l.2.2.4-.5c-.4 0-.6.3-.6.3ZM5.8 7.7v.2-.2ZM6 7.8l-.1.2v-.2ZM6 7.8V8v-.2ZM5.8 7.8V8v-.2Z"></path></svg>`;

const contentRegExp = /<svg(.*?)>(.*?)<\/svg>/s;
const attrRegExp = /(.*?)="(.*?)"/;
const splitAttrExp = /[\w-]+="[^"]*"/g;

const attributeMap = {
  viewbox: "viewBox",
  class: "className",
};

let instanceId = 0;

function Icon(props) {
  const [, attrs, content] = svg.match(contentRegExp);

  const svgAttributes = {};

  for (const stringAttr of attrs.trim().match(splitAttrExp)) {
    let [, key, value] = stringAttr.match(attrRegExp);
    if (key in attributeMap) key = attributeMap[key];
    svgAttributes[key] = value;
  }

  const [obj, setObj] = useState({ svgAttributes, __html: content });

  // On the client, unique IDs are necessary per instance.
  // We will use the fact that React SSR does not run effects!
  useEffect(() => {
    const ids = svg.matchAll(/id="(.*?)"/gm);
    let html = obj.__html;

    for (const [match, id] of ids) {
      const uniqueID = `${id}-${instanceId}`;
      html = html
        .replace(match, 'id="' + uniqueID + '"')
        .replaceAll(`url(#${id})`, `url(#${uniqueID})`)
        .replaceAll(`"#${id}"`, `"#${uniqueID}"`);
    }

    setObj({ svgAttributes, __html: html });

    instanceId++;
  }, []);

  return (
    <svg
      dangerouslySetInnerHTML={obj}
      {...obj.svgAttributes}
      {...props}
    />
  );
}

export default Object.assign(Icon, { svg });
